import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import { makeStyles } from "@mui/styles";
import { Alert } from '@mui/material';

import styles from "assets/jss/material-dashboard-react/components/alertStyle.js";

const useStyles = makeStyles(styles);

export default function CustomAlert(props) {
  const classes = useStyles();
  const {
    alert,
    color,
    children,
    severity,
    className,
    muiClasses,
    ...rest
  } = props;

  const alertClasses = classNames({
    [classes.alert]: true,
    [classes[severity]]: severity,
    [className]: className
  });
  return (
     <Alert {...rest} classes={muiClasses}  className={alertClasses} severity={severity}>
      {children}
      </Alert>
  );
}

CustomAlert.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "white",
    "tele",
    "transparent",
    "text",
    "secondary"
  ]),
  severity: PropTypes.bool,
  className: PropTypes.string,
  // use this to pass the classes props from Material-UI
  muiClasses: PropTypes.object,
  children: PropTypes.node
};
